<div class="flex items-start justify-between gap-3 p-4">
  <div class="min-w-0">
    <h3 class="m-0 text-sm font-semibold text-primary">{{ title() }}</h3>
    @if (subtitle()) {
      <p class="m-0 mt-1 text-xs text-secondary">{{ subtitle() }}</p>
    }
  </div>

  <button
    type="button"
    class="btn-fab-secondary shrink-0 text-secondary"
    [attr.aria-expanded]="expanded()"
    (click)="toggleExpanded()">
    <span class="sr-only">{{ expanded() ? 'Collapse' : 'Expand' }} {{ title() }}</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="size-5 transition-transform"
      [class.rotate-180]="expanded()"
      aria-hidden="true">
      <path d="m6 9 6 6 6-6" />
    </svg>
  </button>
</div>

@if (expanded()) {
  <div
    class="border-t border-border px-4 py-4"
    [class]="warning() ? 'bg-red-50 dark:bg-red-950/30' : ''">
    <ng-content />
  </div>
}
